import { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import SearchableSelect from "../../../Components/SearchableSelect";

export default function ActivityEdit({
    activity,
    control,
    onSave,
    onCancel,
    loadUserOptions
}) {

    const [model, setModel] = useState({
        ID: null,
        Message: "",
        CommentByID: null,
        CommentByName: ""
    });

    const [loading, setLoading] = useState(false);

    // sync prop → local state
    useEffect(() => {
        if (!activity) return;

        setModel({
            ...activity,
            Message: activity.Message || "",
            CommentByID: activity.CommentByID,
            CommentByName: activity.CommentByName,
            
        });

    }, [activity]);

    // =====================
    // HANDLERS
    // =====================

    const handleMessageChange = (e) => {
        setModel(prev => ({
            ...prev,
            Message: e.target.value
        }));
    };

    const handleUserSelect = (opt) => {
        setModel(prev => ({
            ...prev,
            CommentByID: opt?.value,
            CommentByName: opt?.label
        }));
    };

    const handleSubmit = async () => {

        if (!model.Message?.trim()) return;

        setLoading(true);

        const result = await onSave?.(model);

        setLoading(false);

        // success = no error message
        if (!result?.Message) {
            onCancel?.(); // close edit mode
        }
    };

    // =====================
    // RENDER
    // =====================

    return (
        <div className="workitem-activity-edit">

            <Form.Group>
                <Form.Control
                    as="textarea"
                    rows={3}
                    value={model.Message}
                    onChange={handleMessageChange}
                    placeholder="ویرایش یادداشت..."
                />
            </Form.Group>
            <div className="mt-2 form-group">
                <SearchableSelect
                    control={control}
                    value={model.CommentByID}
                    defaultLabel={model.CommentByName}
                    placeholder="انتخاب کاربر..."
                    loadOptions={loadUserOptions}
                    onChange={handleUserSelect}
                />
            </div>

            <div className="mt-2 d-flex justify-content-end gap-2">

                <Button
                    variant="success"
                    size="sm"
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? "در حال ذخیره..." : "ذخیره"}
                </Button>
                <Button
                    variant="danger"
                    size="sm"
                    onClick={onCancel}
                    disabled={loading}
                >
                    انصراف
                </Button>



            </div>

        </div>
    );
}